import { makeContextModule } from '@cian/react-utils';

import { FC, JSX } from 'react';
import { Provider } from 'react-redux';

import { IClientSideState } from 'shared/services/ClientSideState';

export const {
  Context,
  useContext: useClientSideState,
  withContext: withClientSideState,
} = makeContextModule<IClientSideState>({
  contextName: 'ClientSideStateContext',
});

type ClientSideStateContextProviderProps = {
  clientSideState: IClientSideState;
  children: JSX.Element;
};

export const ClientSideStateContextProvider: FC<ClientSideStateContextProviderProps> = props => {
  const { clientSideState, children } = props;

  return (
    <Provider store={clientSideState.store}>
      <Context.Provider value={clientSideState}>{children}</Context.Provider>
    </Provider>
  );
};
